import { api } from "../../../api"

const apiEndpoints = {
  navItems: "/app-layout/nav-items",
}

export const navItemsApi = api.injectEndpoints({
  endpoints: (builder) => {
    return {
      getNavItems: builder.query<NavItemResponse[], QueryParams>({
        query: (params) => {
          return {
            url: apiEndpoints.navItems,
            method: "GET",
            params,
          }
        },
        providesTags: ["NavItems"],
      }),
    }
  },
})

export const { useGetNavItemsQuery } = navItemsApi

type QueryParams = {
  contextType: string
  contextId: string
  isMobileScreen: boolean
}

type NavLinkItem = {
  type: "link"
  id: string
  labelKey: string
  icon: string | null
  path: string
}
type NavLinkGroupItem = Omit<NavLinkItem, "path" | "type"> & {
  type: "linkGroup"
  items: NavItemResponse[]
}

export type NavItemResponse = NavLinkItem | NavLinkGroupItem
